import whatIsForexJson from './content/what-is-forex.json';

export const whatIsForexMock = {
    layoutType: 2,
    data: {
        name: 'what-is-forex-trading',
        areasList: [
            {
                id: 1,
                name: 'WhatIsForexTradingPage',
                componentName: 'Comp:WhatIsForexTradingPage',
                content: JSON.stringify(whatIsForexJson)
            }
        ]
    }
};
